/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2023-03-06 10:39:09
 * @Description:
 */

const PERM = {
  Web: 1,
  Flashmail: 2,
  Yixin: 4,
  Pop: 8,
  Imap: 16,
  Smtp: 32,
  AddrRight: 64,
  AddrVisible: 128,
  BigAttachment: 256,
  IsArchive: 512,
  ReceiveLimit: 1024,
  SendLimit: 2048,
  ResetpassGeneral: 4096,
  ResetpassMobile: 8192,
  Dashi: 16384,
  Activesync: 32768,
  Sirius: 65536,
  IsBindPhone: 131072,
  SecondaryLogon: 262144,
  LoginAlertStatus: 524288,
  LoginAlertMail: 1048576,
  LoginAlertSms: 2097152,
  LockAlertStatus: 4194304,
  LockAlertMail: 8388608,
  LockAlertSms: 16777216
};

export default PERM;
